// Debug - Log when file is loaded
console.log("StrengthSkill.js is being loaded");

/**
 * StrengthSkill.js
 * Manages player strength level which affects melee damage and attack speed
 */

export class StrengthSkill {
  constructor() {
    console.log("StrengthSkill constructor called");
    // Current skill level (1-5)
    this.level = 1;
    
    // Base damage at level 1
    this.baseDamage = 15;
    
    // Maximum damage at level 5
    this.maxDamage = 40;
    
    // Current XP (to be implemented later)
    this.currentXP = 0;
    
    // XP required for next level (placeholder for future implementation)
    this.xpToNextLevel = 100;
    
    // Attack speed multiplier (increases with level)
    this.attackSpeedMultiplier = 1.0;
    
    // Make the strength skill globally accessible for debugging
    window.strengthSkill = this;
    
    console.log("StrengthSkill initialized at level 1");
  }
  
  /**
   * Get current damage based on strength level
   * @returns {number} Calculated damage value
   */
  getDamage() {
    // Linear scaling from baseDamage to maxDamage across 5 levels
    // Level 1: 15 damage
    // Level 5: 40 damage
    const damageRange = this.maxDamage - this.baseDamage;
    const levelProgress = (this.level - 1) / 4; // 0 at level 1, 1 at level 5
    const damage = Math.round(this.baseDamage + (damageRange * levelProgress));
    console.log(`Calculating damage for level ${this.level}: ${damage}`);
    return damage;
  }
  
  /**
   * Get attack speed multiplier based on strength level
   * @returns {number} Speed multiplier value
   */
  getAttackSpeedMultiplier() {
    // Speed increases 10% per level (1.0 to 1.4)
    return 1.0 + ((this.level - 1) * 0.1);
  }
  
  /**
   * Get cooldown time based on strength level
   * @param {number} baseCooldown - Base cooldown time in ms
   * @returns {number} Adjusted cooldown time
   */
  getAdjustedCooldown(baseCooldown) {
    return baseCooldown / this.getAttackSpeedMultiplier();
  }
  
  /**
   * Add XP to strength skill (placeholder for future implementation)
   * @param {number} amount - Amount of XP to add
   * @returns {boolean} True if level up occurred
   */
  addXP(amount) {
    // Placeholder for future XP system implementation
    // This code is not active but ready for future expansion
    /*
    this.currentXP += amount;
    
    // Check for level up
    if (this.currentXP >= this.xpToNextLevel && this.level < 5) {
      this.level++;
      this.currentXP -= this.xpToNextLevel;
      this.xpToNextLevel *= 1.5; // Increase XP required for next level
      return true;
    }
    */
    
    return false;
  }
  
  /**
   * Force set level (for testing/debug)
   * @param {number} level - Level to set (1-5)
   */
  setLevel(level) {
    if (level >= 1 && level <= 5) {
      this.level = level;
    }
  }
} 